import React from "react";
import { motion } from "framer-motion";
import { Check, Phone, Mail } from "lucide-react";
import { WHY_CHOOSE, BRAND } from "@/data";

export default function WhyChoose() {
  return (
    <section
      className="relative z-10 bg-[#14171A] py-20 md:py-32 border-t border-[#A8AEB2]/15"
      data-testid="why-choose-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <span className="font-body text-sm uppercase tracking-[0.4em] text-[#7AB648]">
            The Gormans Difference
          </span>
          <h2 className="font-display uppercase text-5xl md:text-7xl text-white leading-[0.9] mt-4">
            Why Choose Us
          </h2>
          <p className="mt-6 font-body text-base md:text-lg text-[#A8AEB2] max-w-md leading-relaxed">
            A local team that turns up, does the job properly and leaves you with
            work built to last. No shortcuts, no surprises.
          </p>
        </motion.div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#A8AEB2]/15 rounded-sm overflow-hidden border border-[#A8AEB2]/15">
            {WHY_CHOOSE.map((point, i) => (
              <motion.div
                key={point}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}
                className="flex items-start gap-4 bg-[#1E2227] p-8 group transition-colors hover:bg-[#2A2F36]"
                data-testid={`why-choose-item-${i}`}
              >
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#7AB648] text-[#14171A]">
                  <Check size={16} strokeWidth={3} />
                </span>
                <span className="font-head font-medium text-lg text-white tracking-tight">
                  {point}
                </span>
              </motion.div>
            ))}
          </div>

          <div className="mt-6 flex flex-col sm:flex-row gap-4">
            <a
              href={BRAND.phoneHref}
              className="flex items-center gap-3 rounded-sm border border-[#A8AEB2]/20 bg-[#1E2227] px-6 py-4 transition-colors hover:border-[#7AB648]"
              data-testid="why-call-link"
            >
              <Phone size={18} className="text-[#7AB648]" />
              <span className="font-head text-white">{BRAND.phone}</span>
            </a>
            <a
              href={`mailto:${BRAND.email}`}
              className="flex items-center gap-3 rounded-sm border border-[#A8AEB2]/20 bg-[#1E2227] px-6 py-4 transition-colors hover:border-[#7AB648]"
              data-testid="why-email-link"
            >
              <Mail size={18} className="text-[#7AB648]" />
              <span className="font-head text-white">{BRAND.email}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
